<template>
    <div class="header">
        <img class="header-logo" src="@/assets/linenazi_icon.png" alt="" @click="navigateIndex">
        <div class="header-title" @click="navigateIndex">灵能纳茨综合服务网管理员系统</div>
        <a class="header-button" href="https://edgehacker.taobao.com" target="_blank">边缘骇客编程实验室企业店铺</a>

        <div class="login-button">
            <img :src="admin.logo" alt="">
            <div>{{ admin.username }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            admin: {

            }
        }
    },
    props: {

    },
    methods: {
        navigateIndex() {
            if (this.$route.path !== '/') {
                this.$router.push('/');
            }
        },
        loadLoginData() {
            this.admin = JSON.parse(sessionStorage.getItem("license"))
            this.admin.logo =  `https://q4.qlogo.cn/headimg_dl?dst_uin=${this.admin.username}&spec=640`
        }
    },
    mounted() {
        this.loadLoginData()
    }
}
</script>


<style scoped>
.header {
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    box-shadow: 0 2px 8px 0 rgb(99 99 99 / 0.1);
    background-color: #151728;
    z-index: 1;
    position: sticky;
    top: 0;
}

.header-logo {
    width: 40px;
    height: 40px;
    display: flex;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
}

.header-title {
    margin-left: 20px;
    margin-right: auto;
    cursor: pointer;
    color: #FFFFFF;
}

.header-button {
    margin-left: 20px;
    padding: 0 15px;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    border: 2px solid #7393df;
    box-sizing: border-box;
    color: #7393df;
    cursor: pointer;
    text-decoration: none;
}

.header-button:hover {
    background-color: #7393df;
    color: white;
}

.login-button {
    height: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: 5px;
    background-color: #FFFFFF;
    cursor: pointer;
    margin-left: 20px;
    box-shadow: 0 2px 8px 0 rgb(99 99 99 / 0.1);
    color: #7393df;
}

.login-button img {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    box-sizing: border-box;
    display: block;
    padding: 5px;
}

.login-button div {
    padding: 0 20px;
}
</style>